import { render, staticRenderFns } from "./SubTeam2.vue?vue&type=template&id=3c95d8f0&"
import script from "./SubTeam2.vue?vue&type=script&lang=js&"
export * from "./SubTeam2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports